import React, { useState, useEffect } from "react";
import "./tableForm.scss";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import CustomLoader from "../CustomLoader/CustomLoader";
import AllServices from "../../Services/AllServices";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import ConfirmationCard from "../ConfirmationCard/ConfirmationCard";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ViewDetails from "../ViewDetails/ViewDetails";
import { FrontEndURL, status } from "../../Constants/Constants";
import Tooltip from "@mui/material/Tooltip";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format, intlFormat } from "date-fns";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useLocation } from "react-router-dom";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useFetchContext } from "../../Context/FetchContext";
import WsConfirmAlert from "../WsConfirmAlert/WsConfirmAlert";
import LanguageIcon from "@mui/icons-material/Language";
import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";
import AddCustomerForm from "../AddCustomerForm/AddCustomerForm";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import WhatsAppMessageModal from "../WhatsAppMessageModal/WhatsAppMessageModal";

const TableForm = () => {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDeleteCard, setOpenDeleteCard] = useState(false);
  const [openViewDetals, setOpenViewDetails] = useState(false);
  const [openWappCard, setOpenWappCard] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openWappModal, setOpenWappModal] = useState(false);
  const [selectedWappItem, setSelectedWappItem] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [details, setDetails] = useState({});
  const location = useLocation();
  const { shouldFetch, setShouldFetch } = useFetchContext();
  const [wsConfirmAlert, setWsConfirmAlert] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [refNumber, setRefNumber] = useState("");
  const [openEdit, setOpenEdit] = useState(false);
  const [data, setData] = useState({});
  const navigate = useNavigate();

  const shouldRefresh = location.state?.refresh;

  const filteredForms = forms.filter((item) => {
    const matchesStatus = statusFilter ? item.Status === statusFilter : true;
    const matchesName = searchTerm
      ? item.Customer_Fname.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.Customer_Lname.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.Refference_Number.toString()
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.Contact_Number.toLowerCase().includes(searchTerm.toLowerCase())
      : true;

    const itemDate = item.Arriving_DateTime
      ? dayjs(item.Arriving_DateTime).format("YYYY-MM-DD")
      : "";

    const startDateObj = startDate ? format(startDate, "yyyy-MM-dd") : "";
    const endDateObj = endDate ? format(endDate, "yyyy-MM-dd") : "";

    const matchesDateRange =
      (!startDate || itemDate >= startDateObj) &&
      (!endDate || itemDate <= endDateObj);

    return matchesStatus && matchesName && matchesDateRange;
  });

  const showDeleteConfirmAlert = () => {
    return Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
      customClass: {
        actions: "swal-actions-gap",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    });
  };

  const handleOpenCard = async (item) => {
    const result = await showDeleteConfirmAlert();

    if (!result.isConfirmed) return;
    setLoading(true);
    try {
      const response = await AllServices.deleteCustomer(item);

      if (response) {
        fetchForms();
        toast.success("Customer deleted succussfully!");
      }
    } catch (error) {
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenViewDetaisl = (item) => {
    setSelectedItem(item);
    setOpenViewDetails(true);
  };

  const handleCloseCard = () => {
    setOpenDeleteCard(false);
  };

  const handleCopy = (item) => {
    navigator.clipboard.writeText(
      FrontEndURL + `addreference?refId=${item.Refference_Number}`,
    );
    // navigator.clipboard.writeText(item.Generated_Link);
    toast.success("Link copied!");
  };

  const handleContact = async (item) => {
    const referenceNumber = item.Refference_Number;
    const contact_Number = item.Contact_Number;

    const formatPhoneNumber = (rawNumber) => {
      let digitsOnly = rawNumber.replace(/\D/g, "");
      if (digitsOnly.startsWith("0")) {
        digitsOnly = "94" + digitsOnly.substring(1);
      }
      return digitsOnly;
    };
    const customerLink = FrontEndURL + `addreference?refId=${referenceNumber}`;
    const contactNumber = formatPhoneNumber(contact_Number);
    const message = ` Hi, welcome to Cinnamon Lake House... \n please fill out your reference details here:\n \n${customerLink}`;
    const WhatsAppLink = `https://api.whatsapp.com/send?phone=${contactNumber}&text=${encodeURIComponent(
      message,
    )}`;

    if (!WhatsAppLink) {
      toast.error("There is no WhatsApp Link");
    }
    window.open(WhatsAppLink, "_blank");
  };

  const hndleOpenEdit = (item) => {
    setOpenEdit(true);
    setData(item);
  };

  const showConfirmAlert = () => {
    return Swal.fire({
      title: "Are you sure?",
      text: "Do you want add this to web portal?",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Yes, mark as checked out",
      cancelButtonText: "Cancel",
      customClass: {
        actions: "swal-actions-gap",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    });
  };

  const hanldeClickWP = async (item) => {
    const result = await showConfirmAlert();

    if (!result.isConfirmed) return;

    navigate("/adminuser/webportal", {
      state: { refNumber: item.Refference_Number },
    });
  };

  const handleClose = () => {
    setWsConfirmAlert(false);
    setOpenEdit(false);
  };

  //fetch forms
  const fetchForms = async () => {
    try {
      setLoading(true);
      const data = await AllServices.getAllReferenceDetails();
      setForms(Array.isArray(data.data.message) ? data.data.message : []);
    } catch (error) {
      toast.error("There is an error fetching the Customer forms");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  //fetch details
  const fetchDetails = async (refNum) => {
    setLoading(true);
    try {
      const details = await AllServices.gellAllCustomerDetailsById(refNum);
      if (details.data.succuss) {
        setDetails(details.data.message);
        setOpenViewDetails(true);
        setSelectedItem(refNum);
      } else {
        toast.error(details.data.message);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchForms();
  }, []);

  useEffect(() => {
    if (shouldRefresh) {
      fetchForms();
    }
  }, [shouldRefresh]);

  useEffect(() => {
    if (shouldFetch) {
      fetchForms();
      setShouldFetch(false);
    }
  }, [shouldFetch]);

  // disble back way after adding webportal
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const blockBack = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.addEventListener("popstate", blockBack);
    return () => {
      window.removeEventListener("popstate", blockBack);
    };
  }, []);

  return (
    <div className="table-Form-containor">
      {loading && (
        <div className="loader-overlay">
          <CustomLoader />
        </div>
      )}

      {wsConfirmAlert && (
        <div className="loader-overlay">
          <WsConfirmAlert
            name={displayName}
            refNumber={refNumber}
            onClose={handleClose}
          />
        </div>
      )}

      <div className="filter-containor">
        {/* Filter by */}
        <TextField
          label="Search"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="field"
        />

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Start Date"
            value={startDate}
            onChange={(newValue) => {
              setStartDate(newValue);
            }}
            inputFormat="dd/MM/yyyy"
            renderInput={(params) => (
              <TextField {...params} size="small" className="field" />
            )}
          />
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="End Date"
            value={endDate}
            onChange={(newValue) => {
              setEndDate(newValue);
            }}
            inputFormat="dd/MM/yyyy"
            renderInput={(params) => (
              <TextField {...params} size="small" className="field" />
            )}
          />
        </LocalizationProvider>

        <FormControl size="small" className="field">
          <InputLabel>Status</InputLabel>
          <Select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            label="Status"
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="PENDING">Pending</MenuItem>
            <MenuItem value="PROCESSING">Processing</MenuItem>
            <MenuItem value="CONFIRM">Confirm</MenuItem>
          </Select>
        </FormControl>
      </div>

      <TableContainer component={Paper} className="table-containor">
        <Table className="table">
          <TableHead className="table-head">
            <TableRow className="table-row">
              <TableCell className="table-cell">Reference No</TableCell>
              <TableCell className="table-cell">First Name</TableCell>
              <TableCell className="table-cell">Last Name</TableCell>
              <TableCell className="table-cell">Mobile No</TableCell>
              <TableCell className="table-cell">Arriving Date</TableCell>
              <TableCell className="table-cell">Depature Date</TableCell>
              <TableCell className="table-cell">Num Of Adults</TableCell>
              <TableCell className="table-cell">Num Of Kids</TableCell>
              <TableCell className="table-cell">Status</TableCell>
              <TableCell className="table-cell">View</TableCell>
              <TableCell className="table-cell">Get Link</TableCell>
              <TableCell className="table-cell">WA Messages</TableCell>
              <TableCell className="table-cell">Web Portal</TableCell>
              <TableCell className="table-cell">Edit</TableCell>
              <TableCell className="table-cell">Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="table-body">
            {filteredForms.length === 0 ? (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  No matching records found
                </TableCell>
              </TableRow>
            ) : (
              filteredForms.map((item) => (
                <TableRow className="table-row-body" key={item.ID}>
                  <TableCell className="table-cell ref">
                    {item.Refference_Number}
                  </TableCell>
                  <TableCell className="table-cell">
                    {item.Customer_Fname}
                  </TableCell>
                  <TableCell className="table-cell">
                    {item.Customer_Lname}
                  </TableCell>
                  <TableCell className="table-cell">
                    {item.Contact_Number}
                  </TableCell>
                  {/* <TableCell>{item.Arriving_DateTime}</TableCell> */}
                  <TableCell className="table-cell">
                    {dayjs(item.Arriving_DateTime).format("YYYY-MM-DD")}
                  </TableCell>

                  <TableCell className="table-cell">
                    {dayjs(item.Depature_DateTime).format("YYYY-MM-DD")}
                  </TableCell>

                  <TableCell className="table-cell">
                    {item.Num_Of_Adults}
                  </TableCell>
                  <TableCell className="table-cell">
                    {item.Num_Of_Kids}
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        padding: "4px 10px",
                        borderRadius: "50px",
                        backgroundColor:
                          item.Status === status.pending
                            ? "rgba(245, 158, 11, 0.15)"
                            : item.Status === status.processing
                              ? "rgba(59, 130, 246, 0.15)"
                              : item.Status === status.confirm
                                ? "rgba(16, 185, 129, 0.15)"
                                : "rgba(0,0,0,0.05)",
                        color:
                          item.Status === status.pending
                            ? "#d97706"
                            : item.Status === status.processing
                              ? "#2563eb"
                              : item.Status === status.confirm
                                ? "#059669"
                                : "#475569",
                        fontWeight: "600",
                        fontSize: "11px",
                        letterSpacing: "0.5px",
                        textTransform: "uppercase",
                        textAlign: "center",
                        display: "inline-block",
                        minWidth: "75px",
                      }}
                    >
                      {item.Status}
                    </Box>
                  </TableCell>

                  <TableCell className="table-cell">
                    <button
                      className="icon-wrapper visibility"
                      onClick={
                        item.Status === status.pending
                          ? undefined
                          : () => fetchDetails(item.Refference_Number)
                      }
                      disabled={item.Status === status.pending}
                      type="button"
                    >
                      <VisibilityIcon className="icon" />
                      <span>View Details</span>
                    </button>
                  </TableCell>

                  <TableCell className="table-cell">
                    <button
                      className="icon-wrapper copy"
                      onClick={() => handleCopy(item)}
                      disabled={item.Status === status.done}
                      type="button"
                    >
                      <ContentCopyIcon className="icon" />
                      <span>Copy Link</span>
                    </button>
                  </TableCell>

                  <TableCell className="table-cell">
                    <button
                      className="icon-wrapper WA"
                      onClick={() => {
                        setSelectedWappItem(item);
                        setOpenWappModal(true);
                      }}
                      type="button"
                    >
                      <WhatsAppIcon className="icon" />
                      <span>WhatsApp</span>
                    </button>
                  </TableCell>

                  <TableCell className="table-cell">
                    <button
                      className="icon-wrapper WebPortal"
                      onClick={
                        item.Status === status.processing ||
                        item.Status === status.done
                          ? undefined
                          : () => hanldeClickWP(item)
                      }
                      disabled={
                        item.Status === status.processing ||
                        item.Status === status.done ||
                        item.Status === status.pending
                      }
                      type="button"
                    >
                      <LanguageIcon className="icon" />
                      <span>Web Portal</span>
                    </button>
                  </TableCell>

                  <TableCell className="table-cell">
                    <button
                      className="icon-wrapper edit"
                      onClick={() => hndleOpenEdit(item)}
                      type="button"
                    >
                      <EditCalendarOutlinedIcon className="icon" />
                      <span>Edit</span>
                    </button>
                  </TableCell>

                  <TableCell className="table-cell">
                    <button
                      className="icon-wrapper delete"
                      onClick={() => handleOpenCard(item.Refference_Number)}
                      type="button"
                    >
                      <DeleteForeverIcon className="icon" />
                      <span>Delete</span>
                    </button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {openDeleteCard && (
        <div className="loader-overlay">
          <ConfirmationCard
            onClose={() => setOpenDeleteCard(false)}
            item={selectedItem}
            onDeleteSuccess={fetchForms}
          />
        </div>
      )}
      {openViewDetals && (
        <div className="loader-overlay">
          <ViewDetails
            refNum={selectedItem}
            onDetails={details}
            onClose={() => {
              setOpenViewDetails(false);
            }}
            onConfirmSuccess={fetchForms}
          />
        </div>
      )}
      {openEdit && (
        <div className="loader-overlay">
          <AddCustomerForm
            onClick={handleClose}
            btnName="Edit Customer"
            titleName="Edit Guest Information"
            data={data}
            mode="edit"
          />
        </div>
      )}
      {openWappModal && (
        <div className="loader-overlay">
          <WhatsAppMessageModal
            item={selectedWappItem}
            onClose={() => setOpenWappModal(false)}
          />
        </div>
      )}
    </div>
  );
};

export default TableForm;
